var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"comparison"},[(!_vm.isSVip)?_c('div',{staticClass:"btn",on:{"click":_vm.goBuy}},[_vm._v("立即开通")]):_vm._e(),(_vm.isSVip)?_c('div',{staticClass:"btn",on:{"click":_vm.goBuy}},[_vm._v("立即续费")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }